import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const deleteUser = (userId: string, tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    apiPath: `${APIEndPoints.DeleteUser}?userId=${+userId}`,
    method: 'DELETE',
    config: sitConfig(tokens),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { deleteUser }
